import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import CrmKanban from "../pages/CrmKanban/";
import CrmFunnels from "../pages/CrmFunnels/";
import CrmTickets from "../pages/CrmTickets/";
import CrmDashboard from "../pages/CrmDashboard/";
import CrmCalendar from "../pages/CrmCalendar/";
import CrmLead from "../pages/CrmLead/";
import CrmPermissions from "../pages/CrmPermissions/";
import SaleAuditDashboard from "../pages/SaleAuditDashboard/";
import SaleAudits from "../pages/SaleAudits/";
import SaleAuditDetail from "../pages/SaleAuditDetail/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Sso from "../pages/Sso/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/sso" component={Sso} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={Tickets}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route
                  exact
                  path="/crm-kanban"
                  component={CrmKanban}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm-funnels"
                  component={CrmFunnels}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm-tickets"
                  component={CrmTickets}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm-dashboard"
                  component={CrmDashboard}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm-calendar"
                  component={CrmCalendar}
                  isPrivate
                />
                <Route
                  exact
                  path="/crm-lead/:leadId"
                  component={CrmLead}
                  isPrivate
                />
                <Route
                  exact
                  path="/sale-audit-dashboard"
                  component={SaleAuditDashboard}
                  isPrivate
                />
                <Route
                  exact
                  path="/sale-audits"
                  component={SaleAudits}
                  isPrivate
                />
                <Route
                  exact
                  path="/sale-audits/:ticketId"
                  component={SaleAuditDetail}
                  isPrivate
                />
                <Route exact path="/users" component={Users} isPrivate />
                <Route
                  exact
                  path="/crm-permissions"
                  component={CrmPermissions}
                  isPrivate
                />
                <Route
                  exact
                  path="/quickAnswers"
                  component={QuickAnswers}
                  isPrivate
                />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
